import {IPageableRequest, ISearchableRequest} from "../../users/userslisting/dto/get-user-list.dto";


interface ISearchablePageableRequest extends IPageableRequest, ISearchableRequest {
}

export abstract class RequestBuilder<T extends ISearchablePageableRequest> {
    protected request: T = {} as T;

    setSearchValue(search: string) {
        if (search?.trim().length > 0) {
            this.request = {
                ...this.request,
                search: search
            }
        } else {
            delete this.request.search;
        }

        return this;
    }

    setPaging(page: number) {
        if (page != null) {
            this.request = {
                ...this.request,
                page: page
            }
        } else {
            delete this.request.page;
        }

        return this;
    }


    build(): T {
        return Object.keys(this.request).length > 0
            ? this.request
            : null;
    }

}